import moment from "moment-timezone";
import { stages } from "../utils/constants";
import upperFirst from "lodash/upperFirst";

export const formatDate = (date, invalidLabel) => {
  const momentDate = moment(date);
  const zoneName = moment.tz.guess();
  const timezone = `(GMT ${moment.tz(zoneName).format("Z")}) ${zoneName}`;
  return momentDate.isValid()
    ? `${momentDate.format("MM/DD/YYYY hh:mm A")} ${timezone}`
    : invalidLabel;
};

/**
 * Used the same validation as magic-api/_library/libs/notifications.js
 * to make sure the email sending wont fail
 */
export const isValidEmail = (mail) => {
  const emailRegex = new RegExp(/^\w+([+.-]?\w+)*@\w+([.-]?\w+)*\.\w{2,}$/);
  return emailRegex.test(mail);
};

/**
 * determins if the plan is active or pending
 * @param {object} assistantPlan join of the assistant and the plan with this client
 * @returns
 */
export const isPending = (assistantPlan) =>
  !assistantPlan.start_date ||
  moment(assistantPlan.start_date) > moment.now() ||
  assistantPlan.status === stages.PENDING;

/**
 * Formats and normalizes name and removes non alpha numeric characters and extra spaces
 * @param {String} name
 * @returns {String}
 */
export const sanitizeName = (name) =>
  name && normalizeDiacritics(name)
    .replace(/[^\w\s]/gi, "") // remove non alpha numeric characters
    .split(/\s+/g) // split by spaces
    .map(upperFirst)
    .join(" ")
    .trim();

/**
 * Replaces accents and diacritics with normal alphabet
 * @param {String} name
 * @returns {String}
 */
export const normalizeDiacritics = (input) =>
  input.normalize("NFD").replace(/[\p{Diacritic}]/gu, "");

export const getSmartDollarString = (amount, isForceCents) => {
  const amountSign = amount < 0 ? "−" : ""; // Note: minus sign is U+2212 and not U+002D
  const amountAbs = Math.abs(amount);
  const amountCentsString = amountAbs.toFixed(2).split(".")[1];
  const amountDollarsString = Math.floor(amountAbs).toString();
  const amountDollarsStringCommaSeparated = amountDollarsString.replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
  return (
    `${amountSign}$${amountDollarsStringCommaSeparated}` +
    (isForceCents || amountCentsString !== "00" ? `.${amountCentsString}` : "")
  );
};
